(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-estimator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('capgown-delivery-estimator')) {
    class CapgownDeliveryEstimator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.locationToggle = this.querySelector('[data-location-toggle]');
        this.postalPanel = this.querySelector('[data-postal-panel]');
        this.postalInput = this.querySelector('[data-postal-input]');
        this.postalCode = this.querySelector('[data-postal-code]');
        this.postalError = this.querySelector('[data-postal-error]');
        this.quoteStatus = this.querySelector('[data-quote-status]');
        this.quoteError = this.querySelector('[data-quote-error]');
        this.zipPrompt = this.querySelector('[data-zip-prompt]');
        this.fastestLine = this.querySelector('[data-fastest]');
        this.fastestText = this.querySelector('[data-fastest-text]');
        this.policyDialog = this.querySelector('[data-policy-dialog]');
        this.standardLine = this.querySelector('[data-standard]');
        this.standardText = this.querySelector('[data-standard-text]');

        this.locationToggle?.addEventListener('click', () => this.togglePostalPanel());
        this.querySelector('[data-postal-update]')?.addEventListener('click', () => this.updatePostalCode());
        this.postalInput?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.updatePostalCode();
          }
        });

        this.querySelector('[data-policy-open]')?.addEventListener('click', () => this.policyDialog.showModal());
        this.querySelector('[data-policy-close]')?.addEventListener('click', () => this.policyDialog.close());
        // Clicking the backdrop (outside the dialog box) closes it; Escape is native to <dialog>.
        this.policyDialog?.addEventListener('click', (event) => {
          if (event.target === this.policyDialog) this.policyDialog.close();
        });

        let savedPostalCode = null;
        try {
          savedPostalCode = sessionStorage.getItem('capgown-delivery-postal-code');
        } catch (error) {}
        savedPostalCode ||= this.dataset.defaultZip;
        if (savedPostalCode) {
          this.setPostalCode(savedPostalCode);
          this.fetchQuote(savedPostalCode);
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      togglePostalPanel() {
        const opening = this.postalPanel.hidden;
        this.postalPanel.hidden = !opening;
        this.locationToggle.setAttribute('aria-expanded', String(opening));
        if (opening) this.postalInput.focus();
      }

      updatePostalCode() {
        const value = this.postalInput.value.trim();
        if (!/^\d{5}$/.test(value)) {
          this.postalError.textContent = this.dataset.invalidZip;
          this.postalError.hidden = false;
          return;
        }

        this.postalError.hidden = true;
        try {
          sessionStorage.setItem('capgown-delivery-postal-code', value);
        } catch (error) {}
        this.setPostalCode(value);
        this.togglePostalPanel();
        this.fetchQuote(value);
      }

      setPostalCode(value) {
        this.postalCode.textContent = value;
        this.postalInput.value = value;
      }

      setLoading(loading) {
        this.quoteStatus.textContent = loading ? this.dataset.loading : '';
        this.quoteStatus.hidden = !loading;
        this.querySelector('[data-postal-update]')?.toggleAttribute('disabled', loading);
      }

      locale() {
        return document.documentElement.lang || 'en-US';
      }

      /** "Oct 21" for a YYYY-MM-DD date, independent of the shopper's time zone. */
      formatDate(isoDate) {
        const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
        return new Intl.DateTimeFormat(this.locale(), {
          month: 'short',
          day: 'numeric',
          timeZone: 'UTC'
        }).format(new Date(Date.UTC(y, m - 1, d, 12)));
      }

      /** Customer-facing name for the expedited FedEx service. */
      fastestLabel(service) {
        if (/overnight/i.test(service)) return this.dataset.overnight;
        if (/2\s*day/i.test(service)) return this.dataset.twoDay;
        if (/express saver/i.test(service)) return this.dataset.threeDay;
        return service;
      }

      /** "<label>: Est. <strong>Oct 21</strong>" */
      renderLine(target, label, isoDate) {
        const when = document.createElement('strong');
        when.textContent = this.formatDate(isoDate);
        target.replaceChildren(`${label}: ${this.dataset.est} `, when);
      }

      renderEstimate(estimate) {
        const { standard } = estimate;
        // RentalCRM sends `twoDay`, or `oneDay` (2.43+) when 2Day isn't faster than standard.
        const quick = 'twoDay' in estimate ? estimate.twoDay || estimate.oneDay : estimate.fastest;

        if (quick) this.renderLine(this.fastestText, this.fastestLabel(quick.service), quick.arrivesBy);
        this.fastestLine.hidden = !quick;

        if (standard) this.renderLine(this.standardText, this.dataset.freeStandard, standard.arrivesBy);
        this.standardLine.hidden = !standard;
      }

      async fetchQuote(postalCode) {
        if (this.dataset.variantSelected !== 'true' || this.dataset.variantAvailable !== 'true') return;
        if (this.dataset.usMarket !== 'true') return;

        this.abortController?.abort();
        this.abortController = new AbortController();
        this.quoteError.hidden = true;
        this.zipPrompt.hidden = true;
        this.fastestLine.hidden = true;
        this.standardLine.hidden = true;
        this.setLoading(true);

        try {
          const response = await fetch(this.dataset.quoteEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              postalCode,
              country: 'US',
              variantId: this.dataset.variantId,
              weightGrams: Number(this.dataset.weightGrams || 0),
              quantity: 1
            }),
            signal: this.abortController.signal
          });
          const payload = await response.json();
          if (!response.ok || !payload.standard) throw new Error(payload.error || this.dataset.rateError);
          this.renderEstimate(payload);
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.quoteError.textContent = this.dataset.rateError;
          this.quoteError.hidden = false;
        } finally {
          this.setLoading(false);
        }
      }
    }

    customElements.define('capgown-delivery-estimator', CapgownDeliveryEstimator);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["school-collection-shared"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-school-products')) {
    const findGroups = id => Array.from(document.querySelectorAll('cg-school-products')).filter(group => group.dataset.collection === id);
    const resetGroups = id => findGroups(id).forEach(group => {
      group.querySelectorAll('[data-school-product]').forEach(card => { card.hidden = false; });
      group.hidden = !group.querySelector('[data-school-product]') && group.dataset.editor !== 'true';
      delete group.dataset.filtered;
      delete group.dataset.singleGroup;
    });
    customElements.define('cg-school-products', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => document.dispatchEvent(new CustomEvent('cg:school:sections'))); }
      disconnectedCallback() { queueMicrotask(() => document.dispatchEvent(new CustomEvent('cg:school:sections'))); }
    });
    customElements.define('cg-school-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-category], .cg-school-reset');
          if (!button || !this.contains(button)) return;
          this.apply(button.dataset.category || 'all', true);
        }, options);
        document.addEventListener('cg:school:sections', () => this.scheduleRefresh(), options);
        for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
          document.addEventListener(event, () => this.scheduleRefresh(), options);
        }
        document.addEventListener('shopify:section:select', event => {
          const group = event.target.querySelector?.('cg-school-products');
          if (group && group.dataset.collection === this.dataset.collection) this.apply('all', false);
        }, options);
        window.addEventListener('popstate', () => this.refresh(), options);
        this.scheduleRefresh();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        cancelAnimationFrame(this.frame);
        resetGroups(this.dataset.collection);
      }
      scheduleRefresh() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      }
      refresh() {
        if (!this.isConnected) return;
        this.groups = findGroups(this.dataset.collection);
        this.cards = this.groups.flatMap(group => Array.from(group.querySelectorAll('[data-school-product]')));
        this.buttons = Array.from(this.querySelectorAll('[data-category]'));
        const available = new Set(this.cards.flatMap(card => card.dataset.categories.split(',').filter(Boolean)));
        const controlled = this.groups.map(group => group.id).join(' ');
        this.buttons.forEach(button => {
          button.hidden = button.dataset.category !== 'all' && !available.has(button.dataset.category);
          if (controlled) button.setAttribute('aria-controls', controlled);
          else button.removeAttribute('aria-controls');
        });
        this.hidden = this.cards.length === 0 || available.size === 0;
        this.apply(new URL(window.location.href).searchParams.get('cg_category') || 'all', false);
      }
      apply(category, updateUrl) {
        if (!this.cards || !this.buttons) return;
        let selected = this.buttons.find(button => !button.hidden && button.dataset.category === category);
        if (!selected) { category = 'all'; selected = this.buttons.find(button => button.dataset.category === 'all'); }
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
        const ids = new Set();
        this.cards.forEach(card => {
          card.hidden = category !== 'all' && !card.dataset.categories.split(',').includes(category);
          if (!card.hidden) ids.add(card.dataset.productId);
        });
        const visibleGroups = this.groups.filter(group => Array.from(group.querySelectorAll('[data-school-product]')).some(card => !card.hidden));
        const filtered = category !== 'all';
        this.groups.forEach(group => {
          group.hidden = !visibleGroups.includes(group);
          if (!group.querySelector('[data-school-product]') && group.dataset.editor === 'true' && !filtered) group.hidden = false;
          group.dataset.filtered = String(filtered);
          group.dataset.singleGroup = String(filtered && visibleGroups.length === 1);
        });
        this.querySelector('.cg-school-results').hidden = !filtered;
        this.querySelector('[data-result-heading]').textContent = selected?.dataset.heading || '';
        const count = this.querySelector('[data-result-count]');
        if (count) count.textContent = ids.size === 1 ? this.dataset.countOne : this.dataset.countMany.replace('[count]', String(ids.size));
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (filtered) url.searchParams.set('cg_category', category);
          else url.searchParams.delete('cg_category');
          if (url.href !== window.location.href) history.pushState({}, '', url);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
